<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addGoods" v-if="!readonly" style="float:right;margin:10px 15px 10px 0;"></el-button>
    <el-table ref="list" border :data="tableData" style="width: 100%">
      <el-table-column prop="StudentNumber" label="学生编号">
        <template slot-scope="{ row }">
          <!-- <el-select v-model="row.StudentNumber" v-if="!readonly" size="mini" style="width:100%;"  @change="onchange(row)">
            <el-option value="主要参与者" label="主要参与者"></el-option>
            <el-option value="参与者" label="参与者"></el-option>
          </el-select> -->
          <span>{{row.StudentNumber}}</span>
        </template>
      </el-table-column>
     <el-table-column prop="Discount" label="姓名">
        <template slot-scope="{ row, $index }">
            <el-input
                size="mini"
                v-model="row.FullName"
                @focus="onStudentDialog($index)"
                placeholder="点击选择"
                v-if="!readonly"
              ></el-input>
              <span v-else>{{row.FullName}}</span>
        </template>
      </el-table-column>
   
      <el-table-column label="操作" align="center" width="100px" v-if="!readonly">
        <template slot-scope="{ row,$index }">
          <!-- <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click="copy(row,$index)" :underline="false">复制</el-link> -->
          <el-link icon="el-icon-delete" @click="del(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
      <student-dialog
        ref="studentDialog"
        in-dialog
        selectable
        :multiple="false"
        @select="setStudent"
      />
  </div>
</template>
<script>
import studentDialog from "@/components/st/student/listDialog";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    showTax: {
      type: Number,
      default: 0,
    }
  },
  components: {
    studentDialog
  },
  data() {
    return {
      tableData: [],
      tableDel: [],
      // sApi: require("@/api/goods/goods").default,
      // api: require("@/api/sale/stInDoc").default,
      // saleApi: require("@/api/sale/sales").default,
      // account_api: require("@/api/goods/goods").default,
      PriAdjustGoodsList: [],
      tbindex:0,
    };
  },

  methods: {
    onchange(row){
      if(row.T!==0){
          row.T=1
      }
    },
    setStudent(t) {
      console.log(t)
      if(this.tableData[this.tbindex].T !==0){
        this.tableData[this.tbindex].T = 1
      }
      this.tableData[this.tbindex].StudentNumber = t.StudentNumber;
      this.tableData[this.tbindex].StudentId = t.StudentId;
      this.tableData[this.tbindex].FullName = t.FullName;
    },
    onStudentDialog(index) {
      this.tbindex=index
      this.$refs.studentDialog.open().then((that) => {
        that.getData();
      });
    },
    getDataFromOrder(id) {
      this.saleApi.getGoodsList(id).then((res) => {
        this.tableData.forEach(item => {
          if(item.T !== 0) {
            item.T = 2
            this.tableDel.push(item)
          }
        })
        res.Data.forEach(item => {
          item.T = 0;
          item.OrderGoodsId = 0;
        })
        this.tableData = res.Data;
        console.log(this.tableData)
      });
    },

    getData() {
      console.log(this.info)
       this.info.Students.forEach(e=>{
         e.T=null
       })
      this.tableData = this.info.Students
      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row,index) {
      console.log(index)
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(row.T!==0) {
            row.T = 2
            this.tableDel.push(row)
          }
          this.tableData.splice(index,1)
          this.subTable()
        })
    },
    copy(row,index) {
        this.tableData.splice(index,0,{
          ...row
        })
        this.tableData[index].OrderGoodsId = 0
        this.tableData[index].T = 0
        this.subTable()
    },
    addGoods() {
      // let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
        let goods = {
          T: 0,
          StudentId: 0,
          FullName: "",
          StudentNumber: ""
        }
        this.tableData.push(goods)
    },

  },
};
</script>

<style>
.el-link{
  font-size: 14px;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button { -webkit-appearance: none; }

input[type="number"]{ -moz-appearance: textfield; }
</style>